( function () {
	'use strict';

	/* @ngInject */
	function EvidenceViewModalCtrl ( $scope, Session, FILETYPES, fileService ) {
		var self = this;

		self.isDownloading = false;

		function downloadFile ( ev, evidence ) {
			ev.preventDefault();
			ev.stopPropagation();

			var params = {
				'userId'        : Session.getCredentials().PersonnelId,
				'observationId' : $scope.observation.id,
				'type'          : FILETYPES.observation
			};

			var fileId = evidence.url;

			self.isDownloading = true;

			fileService
			.download( fileId, params, evidence.description )
			.finally( function () {
				self.isDownloading = false;
			} );
		}

		self.downloadFile = downloadFile;
	}

	angular
		.module( 'app.components' )
		.controller( 'EvidenceViewModalCtrl', EvidenceViewModalCtrl );

	EvidenceViewModalCtrl.$inject = [ '$scope', 'Session', 'FILETYPES', 'fileService' ];
} )( );
